/**
 * Shared email validation utility.
 * Only validates when something has been typed — email stays optional where it currently is.
 */

const BLOCKED_DOMAINS = new Set([
  'example.com',
  'example.org',
  'test.com',
  'xyz.com',
  'tes.com',
  'localhost',
]);

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validate an email address.
 * Returns null if valid (or empty/blank — email is optional).
 * Returns an error string if invalid.
 */
export function validateEmail(value) {
  const trimmed = (value ?? '')?.trim();

  // Empty is fine — email is optional where it currently is
  if (!trimmed) return null;

  // Basic format check
  if (!EMAIL_REGEX?.test(trimmed)) {
    return 'Please enter a valid email address.';
  }

  const parts = trimmed?.split('@');
  const domain = parts?.[1]?.toLowerCase() ?? '';

  // Blocked exact domains
  if (BLOCKED_DOMAINS?.has(domain)) {
    return `"${domain}" is not a valid email domain. Please use a real address.`;
  }

  // Blocked TLDs
  if (domain?.endsWith('.test') || domain?.endsWith('.invalid')) {
    const tld = domain?.endsWith('.test') ? '.test' : '.invalid';
    return `Addresses ending in "${tld}" are not accepted. Please use a real address.`;
  }

  return null;
}
